import React from "react";

const ConfirmationDialog = React.memo(function ConfirmationDialog({
  open,
  onConfirm,
  onCancel,
  title = "Konfirmasi Perubahan",
  message = "Anda akan mengubah jawaban sebelumnya. Seluruh pertanyaan dan jawaban setelah bagian ini akan dihapus karena alur formulir dapat berubah.\n\nApakah Anda ingin melanjutkan?",
  confirmLabel = "Lanjutkan",
  confirmStyle = "white",
}) {
  if (!open) return null;

  const confirmBg =
    confirmStyle === "red"
      ? "bg-red text-white"
      : "bg-white text-midnight";

  return (
    <div className="spss-modal-backdrop fixed inset-0 z-50 flex items-center justify-center px-6">
      {/* backdrop */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onCancel}
      />

      {/* dialog */}
      <div className="spss-modal-panel relative w-full max-w-md rounded-2xl border border-white/15 bg-[#1a1a2e] p-8 shadow-2xl">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-yellow/10 flex items-center justify-center flex-shrink-0">
            <i className="fa-solid fa-triangle-exclamation text-yellow text-lg" />
          </div>
          <h2 className="text-lg font-bold font-sans text-white">{title}</h2>
        </div>

        <p className="text-white/60 font-sans text-sm leading-relaxed mb-8 whitespace-pre-line">
          {message}
        </p>

        <div className="flex items-center justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="px-6 py-2.5 rounded-xl font-sans text-sm font-semibold text-white/60
              hover:text-white hover:bg-white/10 transition-all duration-300 cursor-pointer"
          >
            Batal
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={`px-6 py-2.5 rounded-xl font-sans text-sm font-bold
              transition-all duration-300 hover:scale-105 hover:shadow-lg cursor-pointer ${confirmBg}`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
});

export default ConfirmationDialog;
